import React from 'react';

const TermsConditions = () => (
  <div className="container py-5">
    <h2>Terms & Conditions</h2>
    <p>This is a demo terms and conditions page for Lichic. Add your terms here.</p>
  </div>
);

export default TermsConditions;
